import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@material-ui/core'
import {
  addEmailDomainRuleService,
  updateEmailDomainRuleService,
} from 'src/api/email-domain-rule'

const RuleDialog = ({ open, onClose, initialData }) => {
  const [domain, setDomain] = useState('')
  const [ruleType, setRuleType] = useState(1) // Default to Whitelist
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (initialData) {
      setDomain(initialData.domain)
      setRuleType(initialData.ruleType)
    } else {
      setDomain('')
      setRuleType(1)
    }
    setError(null)
  }, [initialData, open])

  const handleSubmit = async () => {
    if (!domain) {
      setError('Domain is required')
      return
    }

    setLoading(true)
    setError(null)

    try {
      if (initialData) {
        await updateEmailDomainRuleService({
          id: initialData.id,
          domain,
          ruleType,
        })
      } else {
        await addEmailDomainRuleService({
          domain,
          ruleType,
        })
      }
      onClose(true) // Refresh list
    } catch (err) {
      console.error('Failed to save rule:', err)
      setError(err.response?.data?.message || 'Failed to save rule')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={open} onClose={() => onClose(false)} fullWidth maxWidth="sm">
      <DialogTitle>{initialData ? 'Edit Rule' : 'Add Rule'}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Domain"
          type="text"
          fullWidth
          value={domain}
          onChange={e => setDomain(e.target.value)}
          error={!!error}
          helperText={error}
          disabled={loading}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              handleSubmit()
            }
          }}
        />
        <FormControl fullWidth margin="dense" disabled={loading} style={{ marginTop: 16 }}>
          <InputLabel>Rule Type</InputLabel>
          <Select
            value={ruleType}
            onChange={e => setRuleType(e.target.value)}
          >
            <MenuItem value={1}>Whitelist</MenuItem>
            <MenuItem value={2}>Blacklist</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="primary" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RuleDialog
